import '../AppHeader.css';
import React from 'react';
import psifasHebrewLogo from '../static/psifas_hebrew_logo.svg';
import psifasEnglishLogo from '../static/psifas_english_logo.svg';
import LanguageDropdown from './LanguageDropdown';
import { isRTL, useLanguage } from '../LanguageContext';

interface HeaderProps {
  title?: string;
  subtitle?: string;
  height: string;
  showTitle?: boolean;
}

const AppHeader: React.FC<HeaderProps> = ({ title, subtitle, height, showTitle = true }) => {
  const { language } = useLanguage();

  return (
    <header className='header-content' style={{ height }}>
      <div
        className='header-top'
        style={{ flexDirection: isRTL(language) ? 'row-reverse' : 'row' }}
      >
        <LanguageDropdown />
        <div className='logo-container'>
          <img
            src={isRTL(language) ? psifasHebrewLogo : psifasEnglishLogo}
            alt='Logo'
            className='logo'
          />
        </div>
      </div>

      {showTitle && (
        <div className='title-container'>
          {!!title && <h1 className='title'>{title}</h1>}
          {!!subtitle && <p className='subtitle'>{subtitle}</p>}
        </div>
      )}
    </header>
  );
};

export default AppHeader;
